import { AuthorizedGuard } from './authorized.guard';
import { DevEnvGuard } from './dev-env.guard';

export { AuthorizedGuard, DevEnvGuard };

export default [AuthorizedGuard, DevEnvGuard];
